import { observer } from "mobx-react";
import { IOption, SelectDropdown } from "../../../../../../../../../components/inputs/select-dropdown/select-dropdown";
import { ICompareValueTypeComponentProps } from "../condition-field";
import CustomerStateCompareValueStore from "../../../../../../../stores/compare-value/customer-state-compare-value-store";

const CustomerStateCompareValueField: React.FC<ICompareValueTypeComponentProps> = observer(({store, condition, operatorSelector}) => {
    const compareValueStore: CustomerStateCompareValueStore = store as CustomerStateCompareValueStore;

    const options = compareValueStore.options as IOption[]
    const selectedOption = options.find(o => o.value === compareValueStore.value);

    return (
        <>
            {operatorSelector}    

            <SelectDropdown disabled={!condition.isEditMode} value={selectedOption} options={options} onChange={e => compareValueStore.setValue(e?.value as string)} isSearchable={false} />      
        </>
    );
});

export default CustomerStateCompareValueField;